import React from "react";
import { useLenis } from "../hooks/useLenis";
import { Navbar } from "./wolfland/Navbar";
import { Hero } from "./wolfland/Hero";
import { Services } from "./wolfland/Services";
import { Approach } from "./wolfland/Approach";
import { ContactCTA } from "./wolfland/ContactCTA";
import { Footer } from "./wolfland/Footer";

const WolflandHome = () => {
  useLenis();

  return (
    <div data-testid="wolfland-home" className="bg-black min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Approach />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
};

export default WolflandHome;
